import Link from "next/link";
import styles from "./Button.module.css";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: "primary" | "secondary";
    href?: string;
    target?: string;
    rel?: string;
    children: React.ReactNode;
}

export default function Button({
    variant = "primary",
    href,
    target,
    rel,
    children,
    className,
    ...props
}: ButtonProps) {
    const combinedClassName = `${styles.button} ${styles[variant]} ${className || ""}`;

    if (href) {
        return (
            <Link href={href} className={combinedClassName} target={target} rel={rel}>
                {children}
            </Link>
        );
    }

    return (
        <button className={combinedClassName} {...props}>
            {children}
        </button>
    );
}
